@if (!isLoaded) {
  <lin-spinner></lin-spinner>
}

@if (formError) {
  <div class="lin-form-error">{{ formError }}</div>
}

@if (isLoaded) {
<form lin-layout-form [formGroup]="form" (ngSubmit)="saveData()">
  <lin-layout-form-sections-wrapper>
    <lin-layout-form-section layout="triple">
      <lin-form-label required>{{ 'SETTINGS.PRODUCT_NAME' | translate }}:</lin-form-label>
      <mat-form-field color="accent">
        <input matInput formControlName="name" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('name')" controlName="name"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label required>{{ 'SETTINGS.DOMAIN' | translate }}:</lin-form-label>
      <mat-form-field color="accent">
        <input matInput formControlName="domain" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('domain')" controlName="domain"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label>{{ 'SETTINGS.WEB_URL' | translate }}:</lin-form-label>
      <mat-form-field color="accent">
        <input matInput formControlName="hostApp" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('hostApp')" controlName="hostApp"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label>{{ 'SETTINGS.API_URL' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="hostApi" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('hostApi')" controlName="hostApi"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label>{{ 'SETTINGS.TRACK_URL' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="hostTrack" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('hostTrack')" controlName="hostTrack"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label>{{ 'SETTINGS.MESSENGER_URL' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="hostMessenger" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('hostMessenger')" controlName="hostMessenger"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label>{{ 'SETTINGS.LINK_APP_STORE' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="linkAppStore" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('linkAppStore')" controlName="linkAppStore"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label>{{ 'SETTINGS.LINK_PLAY_MARKET' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="linkPlayMarket" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('linkPlayMarket')" controlName="linkPlayMarket"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label required>{{ 'SETTINGS.DEFAULT_THEME' | translate }}: </lin-form-label>
      <mat-form-field>
        <mat-select formControlName="theme">
          @for (theme of themes; track theme.id) {
            <mat-option [value]="theme.id">{{ theme.name }}</mat-option>
          }
        </mat-select>
        <mat-error>
          <lin-form-field-error [control]="form.get('theme')" controlName="theme"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label required>{{ 'SETTINGS.DEFAULT_CURRENCY' | translate }}: </lin-form-label>
      <mat-form-field>
        <mat-select formControlName="currencyId">
          @for (currency of currencies; track currency.id) {
            <mat-option [value]="currency.id">{{ currency.code + ' - ' + currency.name }}</mat-option>
          }
        </mat-select>
        <mat-error>
          <lin-form-field-error [control]="form.get('currencyId')" controlName="currencyId"></lin-form-field-error>
        </mat-error>
      </mat-form-field>
    </lin-layout-form-section>

    <lin-layout-form-section layout="triple">
      <lin-form-label required>{{ 'SETTINGS.SMS_NAME' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="sms" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('sms')" controlName="sms"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label required>{{ 'SETTINGS.EMAIL_NAME' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="email" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('email')" controlName="email"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label required>{{ 'SETTINGS.NOTIFICATION_EMAIL' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="notificationEmail" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('notificationEmail')" controlName="notificationEmail"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label required>{{ 'SETTINGS.SUPPORT_EMAIL' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="supportEmail" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('supportEmail')" controlName="supportEmail"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label required>{{ 'SETTINGS.SUPPORT_PHONE' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="phoneNumber" placeholder="{{ 'PLACEHOLDERS.PHONE_NUMBER' | translate }}" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('phoneNumber')" controlName="phoneNumber"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label>{{ 'SETTINGS.SUPPORT_PHONE_HOURS' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="phoneWorkingHours" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('phoneWorkingHours')" controlName="phoneWorkingHours"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label>{{ 'SETTINGS.ACCOUNTING_EMAIL' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="accountingEmail" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('accountingEmail')" controlName="accountingEmail"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label>{{ 'SETTINGS.SALES_EMAIL' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="salesEmail" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('salesEmail')" controlName="salesEmail"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label>{{ 'SETTINGS.LINK_KNOWLEDGE_BASE' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="linkKnowledgeBase" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('linkKnowledgeBase')" controlName="linkKnowledgeBase"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label>{{ 'SETTINGS.INTERCOM_ID' | translate }}: </lin-form-label>
      <mat-form-field>
        <input matInput formControlName="intercomId" autocomplete="off" />
        <mat-error>
          <lin-form-field-error [control]="form.get('intercomId')" controlName="intercomId"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      @if (user === 'reseller') {
        <lin-form-label>{{ 'SETTINGS.PRIVACY_POLICY_LINK' | translate }}: </lin-form-label>
        <mat-form-field>
          <input matInput formControlName="privacyPolicyLink" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="form.get('privacyPolicyLink')" controlName="privacyPolicyLink"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-form-label>{{ 'SETTINGS.TERMS_OF_USE_LINK' | translate }}: </lin-form-label>
        <mat-form-field>
          <input matInput formControlName="termsOfUseLink" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="form.get('termsOfUseLink')" controlName="termsOfUseLink"></lin-form-field-error>
          </mat-error>
        </mat-form-field>
      }
    </lin-layout-form-section>

    <lin-layout-form-section layout="triple">
      <lin-form-label>{{ 'SETTINGS.LOGO' | translate }}:</lin-form-label>
      <div class="image-container" fxFlex="45" (click)="fileLogo.click()">
        <span class="image" [style.background-image]="'url(' + logoUrl + ')'"></span>
        <input
          hidden
          type="file"
          name="logo"
          accept="image/png, image/jpeg"
          (change)="uploadImage($event.target.files, 'logo')"
          #fileLogo
        />
        <span class="caption">{{ 'SETTINGS.UPLOAD_LOGO' | translate }}</span>
        @if (logoUrl != defaultLogo) {
          <span
            class="cross-mark"
            (click)="restoreDefaultPicture('logo'); $event.stopPropagation()"
            [matTooltip]="'SETTINGS.RESTORE_DEFAULT_IMAGE' | translate: { value: 'logo' }"
          ></span>
        }
      </div>

      <lin-form-label fxFlexOffset="15px">{{ 'SETTINGS.FAVICON' | translate }}:</lin-form-label>
      <div class="favicon-container" fxFlex="40" (click)="fileImage.click()">
        <figure class="image">
          <img [src]="faviconUrl" />
        </figure>
        <input hidden type="file" accept="image/*" (change)="uploadImage($event.target.files, 'favicon')" #fileImage />
        <span class="caption">{{ 'SETTINGS.UPLOAD_FAVICON' | translate }}</span>
        @if (faviconUrl != defaultFavicon) {
          <span
            default
            class="cross-mark"
            (click)="restoreDefaultPicture('favicon'); $event.stopPropagation()"
            [matTooltip]="'SETTINGS.RESTORE_DEFAULT_IMAGE' | translate: { value: 'favicon' }"
            matTooltipClass="tooltip"
          ></span>
        }
      </div>
    </lin-layout-form-section>
  </lin-layout-form-sections-wrapper>
  <lin-layout-form-toolbar fxFlexOffset="2">
    <lin-form-submit-button [isLoading]="isSubmitting"> {{ 'BUTTONS.SAVE' | translate }} </lin-form-submit-button>
  </lin-layout-form-toolbar>
</form>
}
